import { useApiQuery } from "app/modules/api-client";
import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import { INDUSTRY_ENDPOINT_MIN_DATE } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/industryDataAvailability";

import { useIndustryAvailabilityParams } from "../useIndustryAvailabilityParams";

// The endpoint paginates server-side but returns a bare array with no total.
// We fetch the full top slice once and paginate the sorted rows on the client,
// which also lets the metric switcher re-rank without an extra request.
const TOP_DOMAINS_FETCH_SIZE = 100;

export const useIndustryTopDomains = (category: IFlattenedCategory) => {
    const { params, availability } = useIndustryAvailabilityParams(
        category,
        INDUSTRY_ENDPOINT_MIN_DATE.adintelligenceIndustryTopDomainsList,
    );

    const { data, isLoading, isFetching, isError } = useApiQuery(
        {
            tag: "AdIntelligenceMarketingAssets",
            methodName: "adintelligenceIndustryTopDomainsList",
            options: { enabled: !availability.isFullyUnavailable },
        },
        {
            ...params,
            page: 1,
            pageSize: TOP_DOMAINS_FETCH_SIZE,
        },
    );

    return {
        data: data ?? [],
        isLoading: isLoading || isFetching,
        isError,
        availability,
    };
};
